<!--
 * @Description:
 * @Author: liuwp
 * @Date: 2022-09-22 10:53:00
 * @LastEditors: liuwp
 * @LastEditTime: 2022-10-09 14:49:51
-->
<template>
  <section class="ac-pc-external-select">
    <div class="ac-pc-external-select-top">
      <yxt-button
        v-if="!inStage"
        type="primary"
        @click="importBtnClick"
        >{{ $t('pc_ac_btn_importvisitors').d('导入游客') }}</yxt-button
      >
      <yxt-button
        v-if="!inStage"
        class="mr12"
        :disabled="multipleSelection.length <= 0"
        @click="deleteAll"
        >{{ $t('pc_ac_btn_batch_delete').d('批量删除') }}</yxt-button
      >
      <yxt-input
        v-model="nameOrPhone"
        size="small"
        class="ac-pc-external-select-input"
        :placeholder="$t('pc_ac_name_phone_search').d('请输入姓名/手机号搜索')"
        clearable
        searchable
        @search="search"
      />
    </div>
    <yxt-table
      ref="yxtTable"
      class="mt16"
      :row-key="getRowKey"
      :data="tableData"
      style="width: 100%"
      @select-all="handelSelectCurrent"
      @select="handelSelect"
      @selection-change="handleSelectionChange"
    >
      <yxt-table-column type="selection" width="40"> </yxt-table-column>
      <yxt-table-column width="18" clear-padding="left-right">
        <template slot="header">
          <yxt-dropdown
            custom-elm
            placement="bottom-start"
            @command="handleCommand"
          >
            <i
              slot="default"
              class="yxt-icon-arrow-down yxt-table__selection-arrow-icon"
            ></i>
            <yxt-dropdown-menu slot="dropdown">
              <yxt-dropdown-item command="current">{{
                $t('pc_ac_btn_choose_current').d('选择本页')
              }}</yxt-dropdown-item>
              <yxt-dropdown-item command="all">{{
                $t('pc_ac_btn_choose_all').d('选择全部')
              }}</yxt-dropdown-item>
              <yxt-dropdown-item command="delAll">{{
                $t('pc_ac_clear_choosed').d('清空所选')
              }}</yxt-dropdown-item>
            </yxt-dropdown-menu>
          </yxt-dropdown>
        </template>
      </yxt-table-column>
      <yxt-table-column
        prop="name"
        :label="$t('pc_ac_name').d('姓名')"
        width="150"
      >
        <template slot-scope="scope">
          <yxtbiz-user-name :name="scope.row.name" />
        </template>
      </yxt-table-column>
      <yxt-table-column
        prop="mobile"
        :label="$t('pc_ac_phone').d('手机号')"
        show-overflow-tooltip
      >
      </yxt-table-column>
      <yxt-table-column
        prop="email"
        :label="$t('pc_ac_mail').d('邮箱')"
        show-overflow-tooltip
      >
      </yxt-table-column>
      <yxt-table-column
        v-if="!inStage"
        :label="$t('pc_ac_lbl_operation').d('操作')"
        width="120"
      >
        <template slot-scope="scope">
          <yxt-button type="text" @click="deleteExternaler([scope.row.id])">{{
            $t('pc_ac_lbl_remove').d('移除')
          }}</yxt-button>
        </template>
      </yxt-table-column>
    </yxt-table>
    <div class="ac-pc-external-select-pagination">
      <yxt-pagination
        class="ac-pc-external-select-pagination-cmp"
        :current-page="params.currentPage"
        layout="total, prev, pager, next"
        :page-size="params.pageSize"
        :total="total"
        @current-change="handleCurrentChange"
      />
    </div>
    <import-visitor-drawer v-if="!inStage" :activity-id="activityId" :show-visitor-drawer="showVisitorDrawer" @submited="outerListGet" @closeDrawer="showVisitorDrawer = false" />
  </section>
</template>
<script>
import {
  outerListApi,
  deleteExternalerApi,
  outerSelectListApi
} from '../service';
import importVisitorDrawer from './importVisitorDrawer.vue';

export default {
  props: ['selected'],
  inject: ['activityId', 'inStage'],
  components: { importVisitorDrawer },
  data() {
    return {
      showVisitorDrawer: false,
      tableDataMap: new Map(),
      total: 0,
      nameOrPhone: '',
      params: {
        currentPage: 1,
        pageSize: 10
      },
      tableData: [],
      multipleSelection: [],
      excludeIdList: [],
      selectType: 1 // 数据表头下拉框选择状态，0表示选择全部，1表示非选择全部
    };
  },
  async created() {
    await this.outerListGet();
    // 数据反选
    if (this.selected) {
      this.multipleSelection = this.tableData.filter(item => {
        return this.selected.some(i => i.id === item.id);
      });
      this.checkSelectStatus(this.multipleSelection, 'id');
    }
  },
  methods: {
    importBtnClick() {
      this.showVisitorDrawer = true;
    },
    getRowKey(row) {
      return row.id;
    },
    deleteAll() {
      let ids = this.multipleSelection.map(item => item.id);
      if (ids.length === 0) return;
      this.$confirm(
        this.$t(this.$t('pc_ac_lbl_delete_users') /* 确认要删除选中游客吗？ */),
        this.$t('pc_ac_msg_deleteWork' /* 确认删除 */),
        {
          confirmButtonText: this.$t('pc_ac_btn_sure'),
          cancelButtonText: this.$t('pc_ac_btn_cancel'),
          type: 'warning'
        }
      ).then(() => {
        deleteExternalerApi({
          ids: ids,
          actId: this.activityId,
          allDelFlag: this.selectType === 0 ? 1 : 0
        }).then(res => {
          this.$message.success(this.$t('pc_ac_delete_success').d('删除成功'));
          this.params = {
            currentPage: 1,
            pageSize: 10
          };
          this.outerListGet();
          this.selectType = 1;
        });
      });
    },
    // 选择当前页 | 全部 | 清除全部
    handleCommand(command) {
      // 每次切换之前先清空数据
      this.tableDataMap = new Map();
      this.clearSelectList();
      if (command === 'delAll') {
        this.selectType = 1;
        this.multipleSelection = [];
      } else {
        this.selectType = command === 'current' ? 1 : 0;
        this.multipleSelection = this.tableData;
        this.checkSelectStatus(this.multipleSelection, 'id');
      }
    },
    // 清空选择的数据
    clearSelectList() {
      this.multipleSelection = [];
      this.excludeIdList = [];
      this.selectType = 1;
      this.$refs.yxtTable && this.$refs.yxtTable.clearSelection();
    },
    // 设置选中项
    checkSelectStatus(lists, attr) {
      console.log(1231231, lists);
      this.$nextTick(() => {
        if (!lists || lists.length < 1) return;
        lists.forEach(list => {
          // 如果当页数据已经加载过了
          if (this.tableDataMap.has(list[attr])) {
            // 如果之前点了取消了，再回来，该项设置取消
            if (this.excludeIdList.includes(list[attr])) {
              this.$refs.yxtTable.toggleRowSelection(list, false);
            } else {
              this.$refs.yxtTable.toggleRowSelection(list, true);
            }
          } else {
            // 如果该页未加载过，均选中
            this.$refs.yxtTable.toggleRowSelection(list, true);
          }
          this.tableDataMap.set(list[attr], list);
        });
      });
    },
    // 选择当页全部
    handelSelectCurrent(val) {
      this.selectType = 1;
      this.multipleSelection = val;
      // 当页数据与已选中数据进行对比，包含则是选中， 不包含则是取消
      let mulIdList = this.multipleSelection.map(item => item.id) || [];
      let curIdList = this.tableData.map(item => item.id) || [];
      let pageIsSelAll =
        curIdList.length > 0 &&
        mulIdList.length > 0 &&
        mulIdList.includes(curIdList[0]);
      // 取消选中当页，将该页数据添加到删除数组中，反之，在删除列表中选中的
      if (!pageIsSelAll) {
        this.excludeIdList = [...this.excludeIdList, ...curIdList];
      } else {
        this.tableData.forEach(item => {
          if (this.excludeIdList.includes(item.id)) {
            this.excludeIdList = this.excludeIdList.filter(
              sitem => sitem !== item.id
            );
          }
        });
      }
    },
    // 选中/取消某一项
    handelSelect(selection, row) {
      console.log(selection);
      this.selectType = 1;
      let getSelectIdList = selection.map(item => item.id);
      if (!getSelectIdList.includes(row.id)) {
        this.excludeIdList.push(row.id);
      } else {
        this.excludeIdList = this.excludeIdList.filter(item => item !== row.id);
      }
      this.multipleSelection = selection;
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    search() {
      this.params = {
        currentPage: 1,
        pageSize: 10
      };
      this.tableDataMap = new Map();
      this.outerListGet();
    },
    // 删除
    deleteExternaler(data) {
      this.$confirm(
        this.$t('pc_ac_lbl_delete_user' /* 确认要删除游客吗 */),
        this.$t('pc_ac_msg_deleteWork' /* 确认删除 */),
        {
          confirmButtonText: this.$t('pc_ac_btn_sure'),
          cancelButtonText: this.$t('pc_ac_btn_cancel'),
          type: 'warning'
        }
      ).then(() => {
        deleteExternalerApi({
          actId: this.activityId,
          ids: data
        }).then(res => {
          this.$message.success(this.$t('pc_ac_delete_success').d('删除成功'));
          this.params = {
            currentPage: 1,
            pageSize: 10
          };
          this.outerListGet();
        });
      });
    },
    handleCurrentChange(v) {
      this.params.currentPage = v;
      this.outerListGet();
    },
    // 获取数据
    async outerListGet() {
      const listApi = this.inStage ? outerSelectListApi : outerListApi;
      const res = await listApi(this.activityId, {
        nameOrPhone: this.nameOrPhone,
        limit: this.params.pageSize,
        offset: (this.params.currentPage - 1) * this.params.pageSize
      });
      this.tableData = res.datas;
      this.total = res.paging.count;
      if (this.selectType === 0) {
        this.checkSelectStatus(this.tableData, 'id');
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.ac-pc-external-select {
  .ac-pc-external-select-top {
    .ac-pc-external-select-input {
      width: 240px;
    }
  }
  .ac-pc-external-select-pagination {
    margin-top: 16px;
    display: flex;
    justify-content: flex-end;
  }
}
</style>
